import React, { useContext, useEffect, useState } from "react";
import Box from "../SharedComponents/Box";
import SetupTittle from "../SharedComponents/SetupTittle";
import SetupContainer from "../SharedComponents/SetupContainer";
import SetupInput from "../SharedComponents/SetupInput";
import SetupRadio from "../SharedComponents/SetupRadio";
import SubmitBtn from "../SharedComponents/SubmitBtn";
import SetupDropDown from "../SharedComponents/SetupDropdown";
import axios from "axios";
import HistoryTable from "../SharedComponents/HistoryTable";
import Swal from "sweetalert2";
import GetLocalStorageUserId from "../../sharedComponents/GetLocalStorageuserId";
import { contextProvider } from "../SetupPagesContextApi/SetupPagesContextApi";
import UserTokenHandler from "../../sharedComponents/UserTokenHandler";
import SetupAutoComplete from "../SharedComponents/SetupAutoComplete";

const Country = () => {
   UserTokenHandler();
  const backendUrl = process.env.REACT_APP_API_URL;
  const [fetchedData, setFetchedData] = useState([]);
  const [refetch, setRefetch] = useState(false);
  const { currency, handleDataReload } = useContext(contextProvider);
  console.log(currency);
  useEffect(() => {
    axios
      .get(`${backendUrl}Country`)
      .then((res) => setFetchedData(res.data))
      .catch((err) => console.log(err.message));
  }, [backendUrl, refetch]);
  // input fields handle.

  console.log(GetLocalStorageUserId())

  const initialValue = {
    id: 0,
    companyId: 0,
    name: "",
    isActive: "",
    creatorId: GetLocalStorageUserId(),
    creationDate: new Date(),
    modifierId: GetLocalStorageUserId(),
    modificationDate: new Date(),
    currencyTypeId: 0
  };

  const [formData, setFormData] = useState(initialValue);
  const [willUpdate, setWillUpdate] = useState(false);

  const update = (data) => {
    setFormData({ ...formData, ...data });
  };

  const formHandle = (e) => {
    e.preventDefault();

    if (!willUpdate) {
      axios
        .post(`${backendUrl}Country`, { ...formData })

        .then((res) => {
          console.log(res);
          if (res.status === 201) {
            Swal.fire({
              title: `Country Created Successfully`,
              icon: "success",
            });
            setRefetch((prev) => !prev);
            setFormData(initialValue);
            setWillUpdate(false);
            handleDataReload()
          }
        })
        .catch((err) => console.log(err.message));
    }

    if (willUpdate) {
      console.log(formData);
      axios
        .put(`${backendUrl}Country/${formData.id}`, { ...formData })

        .then((res) => {
          console.log(res);
          if (res.status === 204) {
            Swal.fire({
              title: `Country Updated Successfully`,
              icon: "success",
            });
            setRefetch((prev) => !prev);
            setFormData(initialValue);
            setWillUpdate(false);
            handleDataReload()
          }
        })
        .catch((err) => console.log(err.message));
    }
  };

  return (
    <div>
      <Box top>
        <SetupTittle text="country" />
        <SetupContainer>
          <form className="" onSubmit={formHandle}>
            <div className="grid lg:grid-cols-2 gap-y-4 grid-cols-1 lg:gap-y-[35px] lg:gap-x-[125px]">
              <SetupInput
                name="cost"
                type="text"
                placeHolder="Country name"
                allTimeValue={formData.name}
                valueUpdate={(e) => update({ name: e.target.value })}
              />
              
              <SetupDropDown
                dataOf={"currency"}
                allTimeValue={formData.currencyTypeId}
                valueUpdate={(e) => update({ currencyTypeId: e.target?.value })}
                placeHolder="Currency Type"
                name="id"
              ></SetupDropDown>

              <SetupRadio
                name="isActive"
                placeHolder="Contry status?"
                allTimeValue={formData.isActive}
                valueUpdate={(data) => update({ isActive: data })}
              />
            </div>
            <SubmitBtn text={willUpdate ? "Update" : "Create"} />
            <SubmitBtn
              onClick={() => {
                setWillUpdate(false);
                update(initialValue);
              }}
              styleClass={!willUpdate && "hidden"}
              text="Cancel"
            />
          </form>
        </SetupContainer>
      </Box>
      <Box>
        <SetupTittle text="History" />
        <SetupContainer>
          <HistoryTable
            editCallBack={(data) => {
              update(data);
              setWillUpdate(true);
            }}
            fetchedData={fetchedData}
            headers={["Country name",
               "Currency Type",
                "Status"]}
            row={["name",
              "currencyType",
                "isActive"]}
            extraFields={["currencyTypeId"]}
          />
        </SetupContainer>
      </Box>
    </div>
  );
};

export default Country;
